import { MdEdit } from 'react-icons/md';
import ActivationBadge from './ActivationBadge';
import { CollectionPolicy, overdueLabel, preventiveLabel } from '../collectionModel';

interface CollectionPolicyListProps {
    policies: CollectionPolicy[];
    onEdit: (policy: CollectionPolicy) => void;
    onToggleStatus: (policy: CollectionPolicy) => void;
}

const CollectionPolicyList = ({ policies, onEdit, onToggleStatus }: CollectionPolicyListProps) => {
    const pending = (policy: CollectionPolicy) => policy.rules.filter(r => !r.skip && !r.messageCompositionId).length;

    return (
        <div className="space-y-3">
            <p className="text-sm text-gray-500">Quando cobrar, o que mandar e para quem. O catálogo aponta para uma política por forma de operar e por cliente.</p>
            {policies.length === 0 && (
                <p className="rounded-lg border border-dashed border-gray-300 px-4 py-6 text-center text-sm text-gray-500 dark:border-slate-600">
                    Nenhum item cadastrado
                </p>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {policies.map(policy => (
                    <div key={policy.id}
                        className={`rounded-xl border bg-white dark:bg-slate-800 p-4 space-y-2 ${policy.status === 'INACTIVE' ? 'opacity-60' : ''}`}>
                        <div className="flex items-center gap-2">
                            <span className="font-semibold flex-1">{policy.name}</span>
                            <ActivationBadge status={policy.status} reason={policy.statusReason} />
                        </div>
                        <p className="text-sm text-gray-600 dark:text-gray-300">{policy.description}</p>
                        <dl className="grid grid-cols-[auto_1fr] gap-x-2 text-xs text-gray-500">
                            <dt>Antes do vencimento:</dt><dd>{preventiveLabel(policy.schedules.preventive)}</dd>
                            <dt>Depois do vencimento:</dt><dd>{overdueLabel(policy.schedules.overdue)}</dd>
                        </dl>
                        <div className="text-xs text-gray-500">
                            {policy.rules.length} regra(s)
                            {pending(policy) > 0 && <span className="text-amber-600"> · {pending(policy)} sem composição</span>}
                        </div>
                        {policy.statusReason && <div className="text-xs text-gray-500">Motivo: {policy.statusReason}</div>}
                        <div className="flex gap-3 pt-1">
                            <button type="button" onClick={() => onEdit(policy)}
                                className="inline-flex items-center gap-1 text-xs text-blue-600 hover:underline">
                                <MdEdit size={14} /> Editar
                            </button>
                            <button type="button" onClick={() => onToggleStatus(policy)}
                                className="text-xs text-gray-600 dark:text-gray-300 hover:underline">
                                {policy.status === 'ACTIVE' ? 'Desativar' : 'Reativar'}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CollectionPolicyList;
